import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu';
//import { Footer } from './Footer';
import loaderImage from '../images/loader.svg'
import  NavHeader  from './NavHeader';


export class Layout extends Component {
    static displayName = Layout.name;

  
    render() {
        
        return (
           
            <div className="ltr light-theme horizontalmenu-hover horizontalmenu color-menu header-light">
              
                <div className="horizontalMenucontainer">
                        {/*<div id="global-loader" >*/}
                        {/*    <img src={loaderImage} className="loader-img" alt="Loader" />*/}
                        {/*</div>*/}
                        <div className="page">
                            <NavHeader>
                                
                              {/*  <NavMenu />*/}
                        </NavHeader>
                        <div className="jumps-prevent" style={{ paddingTop: '64.3333px' }}></div>  
                        <NavMenu />
                        <div className="jumps-prevent" style={{ paddingTop: '64.3333px' }}></div>  
                            <div className="main-content pt-0 hor-content">
                            <div className="main-container container">
                                    {this.props.children}
                                </div>
                            </div>
                        </div>
                </div>
            </div>

            //<div>
            //  {/*<NavMenu />*/}
            //  {/*<Container>*/}
            //    {this.props.children}
            //  {/*</Container>*/}
            //</div>
        );
    }
}
